/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamRevisionPublishMutationRequest,
  PostApiV1ExamRevisionPublishMutationResponse,
  PostApiV1ExamRevisionPublish400,
  PostApiV1ExamRevisionPublish401,
  PostApiV1ExamRevisionPublish404,
  PostApiV1ExamRevisionPublish500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionPublish.ts";

function getPostApiV1ExamRevisionPublishUrl() {
  const res = { method: "POST", url: `/api/v1/exam/revision/publish` as const };
  return res;
}

/**
 * @description Publica uma avaliação gerada por IA: cria a prova (Exam) do tipo Avaliação do Aluno, copia os itens do BotExam para a nova prova, gera a publicação principal para a turma/disciplina com as datas e configurações informadas. Opcionalmente cria também a publicação da avaliação docente quando TeacherEvaluationExamId é informado. Atualiza o status do BotExam para Published. **(Requer Authorization para autenticação)**
 * @summary Publicar avaliação gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/publish}
 */
export async function postApiV1ExamRevisionPublish(
  data?: PostApiV1ExamRevisionPublishMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ExamRevisionPublishMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamRevisionPublishMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionPublish400
      | PostApiV1ExamRevisionPublish401
      | PostApiV1ExamRevisionPublish404
      | PostApiV1ExamRevisionPublish500
    >,
    PostApiV1ExamRevisionPublishMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamRevisionPublishUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
